var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v(_vm._s(_vm.titulo))]),
      _c("label", { staticStyle: { color: "#aaaaaa" } }, [
        _vm._v(_vm._s(_vm.subtitulo))
      ]),
      !_vm.getPago.id && !_vm.modificar
        ? _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  staticStyle: {
                    "margin-top": "20px",
                    "margin-bottom": "20px"
                  },
                  attrs: {
                    "vs-type": "flex",
                    "vs-justify": "center",
                    "vs-align": "center",
                    "vs-w": "12"
                  }
                },
                [_vm._v(" Sin información de pago ")]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "form",
        {
          staticStyle: {
            width: "100%",
            "margin-top": "30px",
            "min-height": "400px"
          },
          attrs: { "data-vv-scope": "informacionPago" }
        },
        [
          _vm.getPago.id || _vm.modificar
            ? _c("div", [
                _c("div", { staticClass: "vx-row" }, [
                  _c("div", { staticClass: "vx-col w-full emu-label" }, [
                    _vm._v("Estado de pago")
                  ]),
                  _c(
                    "div",
                    { staticClass: "vx-col w-full" },
                    [
                      _c("vs-select", {
                        attrs: {
                          options: _vm.estadosPago,
                          disabled: !_vm.modificar
                        },
                        model: {
                          value: _vm.tipo,
                          callback: function($$v) {
                            _vm.tipo = $$v
                          },
                          expression: "tipo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.getError("tipo") && _vm.modificar
                    ? _c(
                        "span",
                        {
                          staticClass: "text-danger text-sm form-error-message"
                        },
                        [_vm._v("Debe indicar el tipo de pago")]
                      )
                    : _vm._e()
                ]),
                _c("div", { staticClass: "vx-row mt-2" }, [
                  _c("div", { staticClass: "vx-col w-full emu-label" }, [
                    _vm._v("Medio de pago")
                  ]),
                  _c(
                    "div",
                    { staticClass: "vx-col w-full" },
                    [
                      _c("vs-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          name: "medio",
                          options: _vm.mediosPago,
                          disabled: !_vm.modificar
                        },
                        model: {
                          value: _vm.medio,
                          callback: function($$v) {
                            _vm.medio = $$v
                          },
                          expression: "medio"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.getError("medio") && _vm.modificar
                    ? _c(
                        "span",
                        {
                          staticClass: "text-danger text-sm form-error-message"
                        },
                        [_vm._v("Debe indicar el medio de pago")]
                      )
                    : _vm._e()
                ]),
                _c("div", { staticClass: "vx-row mt-2" }, [
                  _c("div", { staticClass: "vx-col md:w-1/2 w-full" }, [
                    _c(
                      "div",
                      {
                        staticClass: "vs-input--label",
                        staticStyle: {
                          width: "100% !important",
                          display: "block",
                          "margin-top": "4px"
                        },
                        attrs: { for: "" }
                      },
                      [_vm._v("Fecha")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "vs-con-input",
                        staticStyle: {
                          width: "100% !important",
                          display: "block"
                        }
                      },
                      [
                        _c("datepicker", {
                          staticStyle: { width: "90%" },
                          attrs: {
                            name: "fecha",
                            format: _vm.format,
                            placeholder: "",
                            "monday-first": "",
                            language: _vm.es,
                            disabled: !_vm.modificar
                          },
                          model: {
                            value: _vm.fecha,
                            callback: function($$v) {
                              _vm.fecha = $$v
                            },
                            expression: "fecha"
                          }
                        }),
                        _vm.getError("fecha") && _vm.modificar
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "text-danger text-sm form-error-message"
                              },
                              [_vm._v("Fecha de pago es requerida")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "vx-col md:w-1/2 w-full" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric",
                            expression: "'required|numeric'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: {
                          label: "Monto",
                          maxlength: "10",
                          type: "number",
                          name: "monto",
                          disabled: !_vm.modificar
                        },
                        model: {
                          value: _vm.pago.monto,
                          callback: function($$v) {
                            _vm.$set(_vm.pago, "monto", $$v)
                          },
                          expression: "pago.monto"
                        }
                      }),
                      _vm.getError("monto") && _vm.modificar
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger text-sm form-error-message"
                            },
                            [_vm._v("Debe ingresar el monto")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "vx-col w-full" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "max:60",
                            expression: "'max:60'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: {
                          label: "Lugar",
                          maxlength: "60",
                          type: "text",
                          name: "lugar",
                          disabled: !_vm.modificar
                        },
                        model: {
                          value: _vm.pago.lugar,
                          callback: function($$v) {
                            _vm.$set(_vm.pago, "lugar", $$v)
                          },
                          expression: "pago.lugar"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "vx-col w-full mt-3" },
                    [
                      _c("vs-textarea", {
                        attrs: {
                          label: "Comentarios",
                          disabled: !_vm.modificar
                        },
                        model: {
                          value: _vm.pago.comentario,
                          callback: function($$v) {
                            _vm.$set(_vm.pago, "comentario", $$v)
                          },
                          expression: "pago.comentario"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      ),
      !_vm.modificar
        ? _c("div", [
            _c(
              "div",
              { staticStyle: { "text-align": "right" } },
              [
                _c(
                  "vs-button",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { color: "primary", type: "border" },
                    on: {
                      click: function($event) {
                        _vm.modificar = true
                      }
                    }
                  },
                  [_vm._v("Modifícame")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.modificar
        ? _c("div", [
            _c(
              "div",
              { staticStyle: { "text-align": "right" } },
              [
                _c(
                  "vs-button",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { color: "primary", type: "filled" },
                    on: { click: _vm.validarPago }
                  },
                  [_vm._v("Actualizar")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }